/* unplugin-vue-components disabled */import script from "./goodListTable.vue?vue&type=script&setup=true&lang=js"
export * from "./goodListTable.vue?vue&type=script&setup=true&lang=js"

import "./goodListTable.vue?vue&type=style&index=0&id=674cfc10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-674cfc10"]])

export default __exports__